import React from "react";
import { Box, Checkbox, FormControlLabel, Typography } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { PropTypes } from "prop-types";

const useStyles = makeStyles(theme => ({
  formControlLabel: {
    paddingTop: theme.spacing(0.25),
    display: "flex",
    alignItems: "flex-start"
  },
  checkbox: {
    padding: theme.spacing(0.5),
    margin: "0 10px 5px 5px"
  }
}));

const Checklist = ({
  selectAllCheckbox,
  checkboxes,
  onChange,
  onSelectAllChange
}) => {
  const classes = useStyles();
  return (
    <Box display="flex" flexDirection="column">
      {selectAllCheckbox && (
        <Box mb="3px">
          <FormControlLabel
            control={
              <Checkbox
                className={classes.checkbox}
                checked={selectAllCheckbox.checked}
                onChange={({ target: { checked } }) =>
                  onSelectAllChange(checked)
                }
                name={selectAllCheckbox.value}
                color="primary"
              />
            }
            label={
              <Typography variant="subtitle1">
                {selectAllCheckbox.label}
              </Typography>
            }
          />
        </Box>
      )}
      {checkboxes &&
        checkboxes.map((checkbox, index) => (
          <Box mb="-5px" key={index}>
            <FormControlLabel
              control={
                <Checkbox
                  className={classes.checkbox}
                  checked={checkbox.checked}
                  onChange={({ target: { checked } }) =>
                    onChange(checked, checkbox.value, index)
                  }
                  color="primary"
                />
              }
              label={
                <Typography
                  variant="body2"
                  color="textSecondary"
                  sx={{ pt: "5px", pb: 1.25, lineHeight: 1.25 }}
                  className={
                    checkbox.classes && checkbox.classes.label
                      ? checkbox.classes.label
                      : null
                  }
                >
                  {checkbox.label}
                </Typography>
              }
              className={classes.formControlLabel}
            />
          </Box>
        ))}
    </Box>
  );
};

export default Checklist;

Checklist.propTypes = {
  selectAllCheckbox: PropTypes.shape({
    checked: PropTypes.bool,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    label: PropTypes.string
  }),
  checkboxes: PropTypes.arrayOf(
    PropTypes.shape({
      checked: PropTypes.bool,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      label: PropTypes.string,
      classes: PropTypes.shape({
        label: PropTypes.object
      })
    })
  ),
  onChange: PropTypes.func,
  onSelectAllChange: PropTypes.func
};
